import * as Stimulus from "@hotwired/stimulus"

/**
 * Changes the stock textarea behavior to automatically resize
 * based on the length of the input.
 **/
export class ResizableTextareaController extends Stimulus.Controller {
    static classes = ["noResize"];

    connect() {
        if(this.element.type !== 'textarea') {
            console.warn("ResizableTextareaController set on non-textarea:", this.element.type);
        }

        this.noResizeClasses.forEach((cl) => {
            this.element.classList.add(cl);
        });

        this.resize();
    }

    resize() {
        this.element.style.height = "auto";
        this.element.style.height = this.element.scrollHeight + "px";
    }
}
